import { Button, createStyles, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setDialogHandle } from "../../../actions/dialog";
import BacklogDialog from "../Dialogs/BacklogDialog";
import { useOrderBacklog } from "../hooks/useOrderBacklog";
import Styles from './OrderBar.module.scss';
import { useOrders } from "../../util/OrderContext";

const useStyles = makeStyles((theme) => createStyles({
    root: {
        fontWeight: 400,
        borderRadius: "1.25rem"
    }
}));

export function BacklogButton() {
    const { apiData, isLoading, checkOrderBacklog } = useOrderBacklog();
    const { t } = useTranslation();
    const { root } = useStyles()
    const dispatch = useDispatch();
    const { newOrders } = useOrders()!;

    useEffect(() => {
        if (isLoading) return;
        checkOrderBacklog();
        //eslint-disable-next-line
    }, [newOrders.length]);

    function onClick() {
        dispatch(setDialogHandle({
            Component: BacklogDialog,
            ComponentProps: {
            },
            isFormDialog: false,
            styles: { className: Styles.OrderBacklogDialog },
            dialogTitle: " "
        }))
    }

    return <Button
        variant="outlined"
        onClick={onClick}
        className={root}
    >
        {t("misc.Backlog")} <CounterIcon isLoading={isLoading} count={apiData ?? 0} />
    </Button>

}

interface ICounterIconProps {
    isLoading: boolean;
    count: number | null;
}

function CounterIcon({
    isLoading,
    count
}: ICounterIconProps) {
    if (count === null && !isLoading) return null;

    return <span className={Styles.Counter}>
        {isLoading ? <Skeleton /> : count}
    </span>
}